const defaultSize = '1200,9999,fit';

const compress = (path = '', size = '') => {
  if (!path) return path;
  return path.replace(defaultSize, size);
};

export const compressProfilePicture = (path = '') =>
  compress(path, '300,300,fit');
